import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { ServiceListDto } from '../../dto/ServiceListDto';
import { IApiParams } from '../../interface/IApiParams';
import { getApi } from '../getApi';

export const apiMoveToArchive = async (dto: ServiceListDto) => {
  const params: IApiParams = {
    url: '/service/moveToArchive.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'POST', dto);
};
